import { EduIf, FlexContainer } from '@edulastic/common'
import React from 'react'
import {
  ICON_INFO_OVERLAY,
  IconInfoWithTooltip,
} from '../../../../../../common/components/tooltip/IconInfoWithTooltip'
import { StyledInfoIconBlack } from '../../../../../../common/styled'
import { StyledText } from './styled'

export const InfoCell = ({
  title,
  tooltipContent,
  justifyCenter,
  isHeader = false,
}) => {
  return (
    <FlexContainer
      alignItems="center"
      justifyContent={justifyCenter ? 'center' : 'flex-start'}
    >
      <StyledText $bold={isHeader}>{title || '-'}</StyledText>
      <EduIf condition={title}>
        <IconInfoWithTooltip
          title={tooltipContent}
          variant={ICON_INFO_OVERLAY.DARK}
          icon={
            <StyledInfoIconBlack
              $marginLeft="10px"
              $marginTop="0"
              $cursor="pointer"
            />
          }
        />
      </EduIf>
    </FlexContainer>
  )
}
